import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/global.css";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#1a1a1a",
            color: "#f0ebe0",
            border: "1px solid #c9a84c33",
            fontFamily: "'Barlow', sans-serif",
            fontSize: "14px",
          },
          success: { iconTheme: { primary: "#c9a84c", secondary: "#0a0a0a" } },
          error: { iconTheme: { primary: "#e05252", secondary: "#0a0a0a" } },
        }}
      />
    </HelmetProvider>
  </React.StrictMode>
);
